import { alcmeonSupportedLanguages } from 'src/app/mobile/login/supported-languages.const';
import * as Configuration from '../app.constants.js';


routerConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$translateProvider'];
export function routerConfig($stateProvider, $urlRouterProvider, $translateProvider) {

  // wait until angular is bootstrapped before routing,
  // as downgraded angular services are not available before that
  // (the <angular-bootstrap> component will start ui-router when inited)
  $urlRouterProvider.deferIntercept();

  // configure routes
  $urlRouterProvider
    .otherwise(function ($injector, $location) {
      // as described in https://ui-router.github.io/ng1/docs/0.2.18/index.html#/api/ui.router.router.$urlRouterProvider , 
      // the .otherwise method does not support normal dependency injection,
      // so we use a raw $injector by hand
      let XHRStatsFactory = $injector.get('XHRStatsFactory');
      let AlertingFactory = $injector.get('AlertingFactory');
      let $state = $injector.get('$state');

      // We have no idea where we were supposed to go.
      XHRStatsFactory.onUnknownLocation($location.absUrl());
      if ($state.current.name) {
        // we are somewhere ok so, we just display a small warning.
        AlertingFactory.error('unknown-location');
        // and make sure we stay in a safe place.
        return $state.href($state.current, $state.params).slice(1);
      } else {
        // we are nowhere kosher so, we redirect to a safe place.
        console.warn(`couldn't find a matching route, redirect to /a/login`);
        return '/a/login';
      }
    })
    .when('/reset', ['LocalStorageFactory', function (LocalStorageFactory) {
      LocalStorageFactory.clear();
      return '/a/login';
    }])
    .when(/^\/[a-z-]{2,}\/reset\/?$/, ['$match', 'LocalStorageFactory', function ($match, LocalStorageFactory) {
      LocalStorageFactory.clear();
      let url = $match[0].replace(/reset/g, 'login');
      return url;
    }])
    .when('', '/a/login')
    // does not seems usefull and works, because company name can contain number, think about it when migrating routes in NG, and $state.go('auth.alcmeon.after-login') does not work here
    .when(/^\/[a-z-]{2,}\/?$/, ['$match', '$http', '$state', 'ErrorFactory', function ($match, $http, $state, ErrorFactory) {
      // It seems that some users access Alcmeon via /companyName/
      // Let's redirect them to /companyId/
      let companyName = $match[0].replace(/\//g, '');
      $http.get(`${Configuration.constants.baseUrl}api/2.0/companies/${companyName}`)
        .then(function (response) {
          let company = response.data;
          $state.go('auth.alcmeon.after-login', {
            companyId: company.id,
            companyName: company.url_name
          });
        }, response => ErrorFactory.redirectToUnknownCompanyOrToBug(response, companyName));
      return true;
    }])
    // matches /companyId/ . Let's try to have a decent behavior in this case.
    .when(/^\/([0-9]+)\/?$/, '/$1/after-login')

    // Redirect to PDF Upload
    .when('/{companyId}/pdf-upload', ['LoginFactory', function (LoginFactory) {
      window.location.href = `${Configuration.constants.pdfUploadFrontUrl}/routes/auth/upload?jwt=${LoginFactory.getJwt()}`;
    }])

    // ------------  TEMPORARY REDIRECTIONS -----------

    //Changing search - 02/02/2018
    .when('/{companyId}/search/{searchArg}', ['$match', function ($match) {
      //If searchArg is a siteId or 0, it means there is a corresponding old-search url.
      if (/^\d+$/.test($match.searchArg)) {
        let path = '/' + $match.companyId + '/search/tasks';
        return path;
      }
      else {
        // Rule didn't match the url. (ie searchArg not a siteId)
        return false;
      }
    }])
    ;

  function addSatisfactionSurveyStates($stateProvider, navigationMode) {
    $stateProvider
      .state('auth.alcmeon.fuse.parameters.all-accounts.' + (navigationMode === "marketing" ? "marketing-" : "") + 'satisfaction-surveys', {
        url: '/' + (navigationMode === "marketing" ? "marketing-" : "") + 'satisfaction-surveys',
        resolve: {
          satisfactionSurveys: ['$stateParams', 'ParametersFactory', function ($stateParams, ParametersFactory) {
            return ParametersFactory.getSatisfactionSurveys($stateParams.companyId, navigationMode === "marketing").then(function (response) {
              return response.data;
            });
          }]
        },
        data: {
          isMarketingMode: navigationMode === 'marketing',
        },
        views: {
          'container@auth': {
            template: require('../components/parameters/satisfaction-surveys/satisfaction-surveys.html'),
            controller: 'SatisfactionSurveysController'
          },
          'sub-nav@auth': {
            template: '' // a rule in core.scss makes an empty sub-nav disappear altogether
          }
        }
      })
      .state('auth.alcmeon.fuse.parameters.account.' + (navigationMode === "marketing" ? "marketing-" : "") + 'satisfaction-survey-details', {
        url: '/' + (navigationMode === "marketing" ? "marketing-" : "") + 'satisfaction-surveys/:satisfactionSurveyId?selectedTabIndex?zoomToBoxId',
        resolve: {
          survey: ['$stateParams', 'ParametersFactory', function ($stateParams, ParametersFactory) {
            return ParametersFactory.getSatisfactionSurvey($stateParams.companyId, $stateParams.siteId, $stateParams.satisfactionSurveyId)
              .then(response => response.data);
          }],
          allScenarios: ['$stateParams', 'QuickRepliesFactory', function ($stateParams, QuickRepliesFactory) {
            return QuickRepliesFactory.getScenarios($stateParams.companyId, 'all-flavors')
              .then(function (response) {
                return response.data;
              });
          }],
        },
        data: {
          isMarketingMode: navigationMode === 'marketing'
        },
        views: {
          'container@auth': {
            template: require('../components/parameters/satisfaction-surveys/satisfaction-survey.html'),
            controller: 'SatisfactionSurveyDetailsController'
          },
          'sub-nav@auth': {
            template: '' // a rule in core.scss makes an empty sub-nav disappear altogether
          }
        }
      })
  }

  function _translationsAsPromise(languageCode) {
    const hasSupportedLanguage = alcmeonSupportedLanguages.includes(languageCode);
    if (!hasSupportedLanguage) {
      console.info(`Language "${languageCode}" not supported, fallback to english.`);
    }
    const languageCodeSupported = hasSupportedLanguage ? languageCode : 'en';

    // see https://webpack.js.org/api/module-methods/#dynamic-expressions-in-import
    return import(`../../assets/i18n/${languageCodeSupported}.json`);
  }

  $stateProvider
    .state('platform-unavailable', {
      url: '/a/platform-unavailable',
      views: {
        'main': {
          template: require('../components/error/platform-unavailable.html'),
        },
      }
    })
    .state('no-auth', {
      abstract: true,
      url: '',
      resolve: {
        browserLang: ['$http', 'AppFactory', 'LoginFactory', 'ErrorFactory', function ($http, AppFactory, LoginFactory, ErrorFactory) {
          return $http.get(Configuration.constants.baseUrl + 'browser-language')
            .then(function (response) {
              LoginFactory.computeShouldReloadLatestClient(response.headers('Latest-Hash'));
              let available = (response.data || []).filter(lang => AppFactory.getAvailableLanguages().findIndex(i => i === lang) !== -1);
              available.push('en'); // make sure we have a default value
              return available[0];
            },
              ErrorFactory.redirectToPlatformUnavailableCb());
        }],
        translations: ['browserLang', function (browserLang) {
          return _translationsAsPromise(browserLang);
        }],
        translationsSetup: ['browserLang', 'translations', '$translate', 'tmhDynamicLocale', 'AppFactory',
          function (browserLang, translations, $translate, tmhDynamicLocale, AppFactory) {
            $translateProvider.translations(browserLang, translations);
            $translateProvider.preferredLanguage(browserLang);
            $translate.use(browserLang);
            let langToLocale = AppFactory.getAvailableLocales();
            tmhDynamicLocale.set(langToLocale[browserLang]);
            return { status: 'ok' };
          }]
      },
      views: {
        'main': {
          template: require('../main-no-auth.html'),
        }
      }
    })
    .state('no-auth.companyless', {
      url: '/a',
      abstract: true
    })
    .state('no-auth.companyless.unknown-company', {
      url: '/unknown-company',
      params: {
        companyName: null,
      },
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/error/error-unknown-company.html'),
          controller: ['$scope', '$stateParams', function ($scope, $stateParams) {
            $scope.companyName = $stateParams.companyName;
          }]
        },
      }
    })
    .state('no-auth.companyless.login', {
      url: "/login",
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/login/company-selection.html'),
          controller: 'CompanySelectionController'
        }
      }
    })
    .state('no-auth.company', {
      abstract: true,
      url: '/{companyName:[a-z-]{2,}[a-z0-9-]*}',
      resolve: {
        company: ['$stateParams', '$http', 'ErrorFactory',
          function ($stateParams, $http, ErrorFactory) {
            const { companyName } = $stateParams;
            return $http.get(`${Configuration.constants.baseUrl}api/2.0/companies/${companyName}`)
              .then(
                response => response.data,
                response => ErrorFactory.redirectToUnknownCompanyOrToBug(response, companyName)
              );
          }]
      }
    })
    .state('no-auth.company.login', {
      url: '/login?forceSelection&showInactive&destUrl',
      params: {
        destUrl: null,
        destState: null,
        selectedLoginOption: null,
        errorMessageKey: null // Message added in case of redirection to login page after receiving a 403 status code
      },
      views: {
        'no-auth-container@no-auth': {
          template: '',
          controller: 'PreLoginController'
        }
      }
    })
    .state('no-auth.company.login-option-selection', {
      url: '/login-option-selection',
      params: {
        destUrl: null,
        destState: null,
        loginOptions: null,
        errorMessageKey: null
      },
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/login/login-option-selection.html'),
          controller: 'LoginOptionSelectionController'
        }
      }
    })
    .state('no-auth.company.login-in-alcmeon', {
      url: '/alcmeon-login',
      params: {
        destUrl: null,
        destState: null,
        errorMessageKey: null
      },
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/login/login-in-alcmeon.html'),
          controller: 'LoginInAlcmeonController'
        }
      }
    })
    .state('no-auth.company.login-in-alcmeon-from-backoffice-success', {
      url: '/alcmeon-login-from-backoffice-success?jwt&destUrl&warnAdminUser',
      views: {
        'no-auth-container@no-auth': {
          template: '',
          controller: ['company', 'LoginFactory', '$stateParams', function (company, LoginFactory, $stateParams) {
            const warnAdminUser = Boolean(Number($stateParams.warnAdminUser));
            LoginFactory.doBackofficeLogin(company.id, $stateParams.jwt, $stateParams.destUrl, warnAdminUser);
          }]
        }
      }
    })
    .state('no-auth.company.saml-success', {
      url: '/saml-success?jwt&destUrl',
      views: {
        'no-auth-container@no-auth': {
          template: '',
          controller: ['company', 'LoginFactory', '$stateParams', function (company, LoginFactory, $stateParams) {
            LoginFactory.doSamlLogin(company.id, $stateParams.jwt, $stateParams.destUrl);
          }]
        }
      }
    })
    .state('no-auth.company.saml-error', {
      url: '/saml-error?type&data&email&nameid',
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/saml-error/saml-error.html'),
          controller: 'SamlErrorController'
        }
      }
    })
    .state('no-auth.company.password-request', {
      url: '/password-request',
      views: {
        'no-auth-container@no-auth': {
          template: '<angular-password-request [company-id]="companyId"></angular-password-request>',
          controller: ['$scope', 'company', function ($scope, company) {
            // At this moment companyId is not know in AlcmeonContextService.
            $scope.companyId = company.id;
          }]

        }
      }
    })
    .state('no-auth.company.password-confirm', {
      url: '/password-confirm/{confirmationId:int}/{confirmationUid}',
      resolve: {
        confirm: ['PasswordConfirmFactory', 'company', '$stateParams', '$state',
          function (PasswordConfirmFactory, company, $stateParams, $state) {
            return PasswordConfirmFactory.get(company.id, $stateParams.confirmationId, $stateParams.confirmationUid)
              .then(function (response) {
                return response.data;
              }, function () {
                $state.go("no-auth.company.password-confirm-expired", { companyName: company.url_name });
              });
          }]
      },
      views: {
        'no-auth-container@no-auth': {
          template: '<angular-user-preferences-password-change [confirm]="confirm"></angular-user-preferences-password-change>',
          controller: ['$scope', 'confirm', function ($scope, confirm) {
            $scope.confirm = confirm;
          }]
        }
      }
    })
    .state('no-auth.company.password-confirm-expired', {
      url: '/password-confirm/expired',
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/password-confirm/password-confirm-expired.html')
        }
      }
    })
    .state('no-auth.company.task-not-found', {
      url: '/task-not-found',
      views: {
        'no-auth-container@no-auth': {
          template: '<h1><span translate-once="task-not-found"></span></h1>'
        },
      }
    })
    .state('no-auth.company.logout-successful', {
      url: '/logout-successful',
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/logout/logout-successful.html'),
          controller: ['$scope', '$stateParams', 'company', function ($scope, $stateParams, company) {
            $scope.frontendBaseUrl = Configuration.constants.frontendBaseUrl;
            $scope.company = company;
          }]
        },
      }
    })
    .state('no-auth.company.bug', {
      url: '/bug/{id:int}',
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/bug/bug.html'),
          controller: ['$scope', '$stateParams', 'company', function ($scope, $stateParams, company) {
            $scope.bugId = $stateParams.id;
            $scope.frontendBaseUrl = Configuration.constants.frontendBaseUrl;
            $scope.company = company;
          }]
        },
      }
    })
    .state('no-auth.company.error-500', {
      url: '/errors/500',
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/error/error-500.html'),
          controller: ['$scope', 'company', function ($scope, company) {
            $scope.baseUrl = Configuration.constants.baseUrl;
            $scope.company = company;
          }]
        },
      }
    })
    .state('no-auth.company.error-403', {
      url: '/errors/403',
      params: { destUrl: null },
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/error/error-403.html'),
          controller: ['$scope', '$stateParams', 'company', function ($scope, $stateParams, company) {
            $scope.destUrl = $stateParams.destUrl;
            $scope.baseUrl = Configuration.constants.baseUrl;
            $scope.company = company;
          }]
        },
      }
    })
    .state('no-auth.company.error-404', {
      url: '/errors/404',
      views: {
        'no-auth-container@no-auth': {
          template: require('../components/error/error-404.html'),
          controller: ['$scope', 'company', function ($scope, company) {
            $scope.baseUrl = Configuration.constants.baseUrl;
            $scope.company = company;
          }]
        },
      }
    })

    .state('auth', {
      abstract: true,
      url: '',
      views: {
        'main': {
          template: require('../main-auth.html')
        }
      }
    })
    .state('auth.alcmeon', {
      abstract: true,
      url: '/:companyId',
      resolve: {
        browserLang: ['$http', 'AppFactory', 'LoginFactory', 'ErrorFactory', function ($http, AppFactory, LoginFactory, ErrorFactory) {
          return $http.get(Configuration.constants.baseUrl + 'browser-language')
            .then(function (response) {
              LoginFactory.computeShouldReloadLatestClient(response.headers('Latest-Hash'));
              let available = response.data.filter(lang => AppFactory.getAvailableLanguages().findIndex(i => i === lang) !== -1);
              available.push('en'); // make sure we have a default value
              return available[0];
            },
              ErrorFactory.redirectToPlatformUnavailableCb());
        }],
        defaultTranslationsData: ['browserLang', function (browserLang) {
          return _translationsAsPromise(browserLang);
        }],
        defaultTranslationsSetup: ['defaultTranslationsData', 'browserLang', '$translate', 'tmhDynamicLocale', 'AppFactory',
          function (defaultTranslationsData, browserLang, $translate, tmhDynamicLocale, AppFactory) {
            $translateProvider.translations(browserLang, defaultTranslationsData);
            $translateProvider.preferredLanguage(browserLang);
            $translate.use(browserLang);
            let langToLocale = AppFactory.getAvailableLocales();
            tmhDynamicLocale.set(langToLocale[browserLang]);
            return { status: 'ok' };
          }],
        loggedUserDescription: ['$stateParams', 'UserFactory',
          function ($stateParams, UserFactory) {
            const { companyId } = $stateParams;
            return UserFactory.loadLoggedUser(companyId)
              .then(response => {
                const loggedUser = response.data[0];
                if (!UserFactory.getCompanyUrlNameFromStorage(companyId)) {
                  UserFactory.storeCompanyUrlName(companyId, loggedUser);
                }
                return loggedUser;
              });
          }],
        translationsData: ['loggedUserDescription', function (loggedUserDescription) {
          return _translationsAsPromise(loggedUserDescription.lang || 'fr');
        }],
        loggedUser: ['UserFactory', 'tmhDynamicLocale', '$translate', 'loggedUserDescription', 'translationsData', 'AppFactory',
          'AngularAlcmeonContextService', 'AngularTranslateService',
          function (UserFactory, tmhDynamicLocale, $translate, loggedUserDescription, translationsData, AppFactory,
            AngularAlcmeonContextService, AngularTranslateService) {
            $translateProvider.translations(loggedUserDescription.lang, translationsData);
            $translateProvider.preferredLanguage(loggedUserDescription.lang);
            $translate.use(loggedUserDescription.lang);
            UserFactory.setLoggedUser(loggedUserDescription);
            let langToLocale = AppFactory.getAvailableLocales();
            tmhDynamicLocale.set(langToLocale[loggedUserDescription.lang]);

            // init angular (that is, the mobile app) context
            AngularAlcmeonContextService.self = loggedUserDescription;
            AngularAlcmeonContextService.lang = loggedUserDescription.lang;
            AngularTranslateService.use(loggedUserDescription.lang);
            return loggedUserDescription;
          }],
        company: ['loggedUser', 'AngularAlcmeonContextService',
          function (loggedUser, AngularAlcmeonContextService) {
            let company = loggedUser.companies[0];

            // init angular (that is, the mobile app) context
            AngularAlcmeonContextService.setCompanyInfo(company);
            AngularAlcmeonContextService.setCompanyNameInTabTitle(company.name);
            return company;
          }],
        siteGroups: ['AngularSitesService', 'company', function (AngularSitesService) {
          return AngularSitesService.getSiteGroupsResolver();
        }],
        siteGroupsMap: ['AngularSitesService', 'siteGroups', function (AngularSitesService) {
          return AngularSitesService.getSiteGroupsMapResolver();
        }],
        sites: ['AngularSitesService', 'company', 'siteGroups', function (AngularSitesService, _, siteGroups) {
          return AngularSitesService.getSitesResolver(siteGroups);
        }],
        sitesMap: ['AngularSitesService', 'sites', function (AngularSitesService) {
          return AngularSitesService.getSitesMapResolver();
        }],
        initFromSelf: ['sitesMap', 'AngularAlcmeonContextService', 'loggedUser', function (sitesMap, AngularAlcmeonContextService, loggedUser) {
          return new Promise((resolve) => {
            AngularAlcmeonContextService.tasksListSettingsHelper.initFromSelf(loggedUser, sitesMap);
            resolve();
          })
        }],
        careMetrics: ['AngularMetricsService', 'company', function (AngularMetricsService) {
          return AngularMetricsService.getMetrics('care').toPromise();
        }],
        marketingMetrics: ['AngularMetricsService', 'company', function (AngularMetricsService) {
          return AngularMetricsService.getMetrics('marketing').toPromise();
        }]
      },
      views: {
        'side-nav': {
          template: require('../components/core/sidenav/alc-sidenav.html'),
          controller: 'AlcSidenavController'
        },
        'websocket': {
          template: '',
          controller: ['$scope', '$rootScope', '$stateParams', 'AngularWebSocketService',
            function ($scope, $rootScope, $stateParams, AngularWebSocketService) {
              $scope.companyId = $stateParams.companyId;
              AngularWebSocketService.createAndOpenWebSocketFromAJSApp(
                $stateParams.companyId,
                event => $rootScope.$applyAsync(() => $rootScope.$emit(event.type, event)));
              $scope.$on('$destroy', () => AngularWebSocketService.closeWebSocket());
            }]
        },
        'notifications': {
          template: require('../components/notifications/notifications.html'),
          controller: 'NotificationsController'
        }
      }
    })
    // not after login, but when clicking inbox icon in left side nav menu (and others $state.go in code base)
    .state('auth.alcmeon.after-login', {
      url: '/after-login',
      views: {
        'container@auth': {
          template: '',
          controller: ['loggedUser', '$state', 'company', 'initFromSelf', function (loggedUser, $state, company) {
            const stateParams = { companyId: company.id };
            if (loggedUser.is_in_push_mode === 1) {
              $state.go('auth.alcmeon.pushbox', stateParams);
            } else {
              if (loggedUser) {
                const { default_queue_id } = loggedUser;
                const stateName = 'auth.alcmeon.inbox.list.tasks';
                if (default_queue_id) {
                  $state.go(stateName, { ...stateParams, queueId: default_queue_id });
                } else {
                  $state.go(stateName, stateParams);
                }
              }
            }
          }]
        }
      }
    })
    .state('auth.alcmeon.fuse', {
      abstract: true,
      url: '/fuse'
    })
    .state('auth.alcmeon.fuse.segments', {       // SEGMENTS
      url: '/segments',
      params: {
        redirectedFromAudience: false
      },
      data: {
        isMarketingMode: true
      },
      resolve: {
        scenarios: ['$stateParams', 'MetricsFactory', function ($stateParams, MetricsFactory) {
          return MetricsFactory.getScenarios($stateParams.companyId, 'quick-replies')
            .then(response => response.data);
        }],
        surveyScenarios: ['$stateParams', 'MetricsFactory', function ($stateParams, MetricsFactory) {
          return MetricsFactory.getScenarios($stateParams.companyId, 'satisfaction-survey')
            .then(response => response.data);
        }],
        redirectedFromAudience: ['$stateParams', function ($stateParams) {
          return $stateParams.redirectedFromAudience;
        }]
      },
      views: {
        'container@auth': {
          template: require('../components/segments/segments-material.html'),
          controller: 'SegmentsController'
        }
      }
    })

    .state('auth.alcmeon.fuse.users-roles', {   // USERS-ROLES
      url: '/users-roles',
      params: {
        tabIndex: 0
      },
      resolve: {
        openRolesTab: ['$state', function ($state) {
          return $state.current.name === 'auth.alcmeon.fuse.role-edit'
            && $state.params.trackTable === 'roles';
        }],
        openTeamsTab: ['$state', function ($state) {
          return $state.current.name === 'auth.alcmeon.fuse.team-edit'
            && $state.params.trackTable === 'teams';
        }]
      },
      views: {
        'sub-nav@auth': {
          template: require('../components/core/subnav/navigation.parameters.html'),
          controller: 'NavigationParametersController'
        },
        'container@auth': {
          template: '<angular-users-permissions></angular-users-permissions>',
        }
      }
    })
    .state('auth.alcmeon.fuse.user-edit', {
      url: '/user-edit/:id',
      views: {
        'container@auth': {
          template: require('../components/users-roles/user-edition-material.html'),
          controller: 'UserEditionController'
        }
      }
    })
    .state('auth.alcmeon.fuse.role-edit', {
      url: '/role-edit',
      params: {
        role: {},
        trackTable: 'users',
        user: {}
      },
      resolve: {

      },
      views: {
        'container@auth': {
          template: require('../components/users-roles/role-edition-material.html'),
          controller: 'RoleEditionController'
        }
      }
    })
    .state('auth.alcmeon.fuse.team-edit', {
      url: '/team-edit',
      params: {
        team: {},
        trackTable: 'users',
        user: {}
      },
      resolve: {

      },
      views: {
        'container@auth': {
          template: require('../components/users-roles/team-edition-material.html'),
          controller: 'TeamEditionController'
        }
      }
    })

    .state('auth.alcmeon.fuse.favorites', {
      url: '/favorites',
      resolve: {

      },
      views: {
        'container@auth': {
          template: require('../components/favorites-editor/favorites-material.html'),
          controller: 'FavoritesController'
        }
      }
    })
    .state('auth.alcmeon.fuse.verbatim', {
      url: '/verbatim',
      resolve: {
        scenarios: ['AngularMetricsService', function (AngularMetricsService) {
          return AngularMetricsService.getScenariosSimplifiedInfo('satisfaction-survey', true).toPromise();
        }],
        metrics: ['AngularMetricsService', function (AngularMetricsService) {
          return AngularMetricsService.getMetrics('care').toPromise();
        }],
        navigationMode: () => 'care',
      },
      views: {
        'container@auth': {
          template: require('../components/verbatim/verbatim.html'),
          controller: 'VerbatimController'
        },
        'sub-nav@auth': {
          template: require('../components/core/subnav/navigation.metrics.html'),
          controller: 'NavigationMetricsController'
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters', {
      abstract: true,
      url: '/parameters',
      views: {
        'sub-nav@auth': {
          template: require('../components/core/subnav/navigation.parameters.html'),
          controller: 'NavigationParametersController'
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.sftp-servers', {
      url: '/sftp-servers',
      resolve: {
      },
      views: {
        'container@auth': {
          template: require('../components/parameters/sftp-servers/sftp-servers-list.html'),
          controller: 'SftpServersListController'
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.sftp-exports', {
      url: '/sftp-exports',
      resolve: {
      },
      views: {
        'container@auth': {
          template: require('../components/parameters/sftp-exports/sftp-exports-list.html'),
          controller: 'SftpExportsListController'
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.priority-rules', {
      url: '/priority-rules',
      views: {
        'container@auth': {
          template: require('../components/parameters/priority-rules/priority-rules.html'),
          controller: 'PriorityRulesController'
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.triage', {
      url: '/triage?triageRuleId&blinkRuleId',
      views: {
        'container@auth': {
          template: require('../components/parameters/triage/triage.html'),
          controller: 'TriageController'
        },
        'sub-nav@auth': {
          template: '' // a rule in core.scss makes an empty sub-nav disappear altogether
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.business-hours', {
      url: '/business-hours',
      resolve: {
        businessHoursConfig: ['$stateParams', 'BusinessHoursFactory', function ($stateParams, BusinessHoursFactory) {
          return BusinessHoursFactory.getBusinessHoursConfig($stateParams.companyId).then(response => response.data);
        }]
      },
      views: {
        'container@auth': {
          template: require('../components/parameters/business-hours/business-hours-params.html'),
          controller: 'BusinessHoursParamsController'
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.applications', {
      url: '/applications',
      resolve: {
        applications: ['$stateParams', 'ApplicationsFactory', function ($stateParams, ApplicationsFactory) {
          return ApplicationsFactory.getApplications($stateParams.companyId).then(response => response.data);
        }]
      },
      views: {
        'container@auth': {
          template: require('../components/parameters/applications/applications.html'),
          controller: 'ApplicationsController'
        },
      }
    })
    .state('auth.alcmeon.fuse.parameters.edit-application', {
      url: '/applications/:applicationId',
      resolve: {
        application: ['$stateParams', 'ApplicationsFactory', function ($stateParams, ApplicationsFactory) {
          return ApplicationsFactory.getApplication($stateParams.companyId, $stateParams.applicationId)
            .then(response => response.data);
        }]
      },
      views: {
        'container@auth': {
          template: require('../components/parameters/applications/application.html'),
          controller: 'ApplicationController'
        },
      }
    })
    .state('auth.alcmeon.fuse.parameters.all-accounts', {
      url: '/all-accounts',
      abstract: true
    })
    .state('auth.alcmeon.fuse.parameters.account', {
      url: '/account/:siteId',
      abstract: true,
      resolve: {
        site: ['$stateParams', 'ParametersFactory', function ($stateParams, ParametersFactory) {
          return ParametersFactory.getSite($stateParams.companyId, $stateParams.siteId).then(response => response.data);
        }]
      }
    })

    .state('auth.alcmeon.fuse.parameters.accounts', {
      url: '/accounts?selectedTabIndex&channel',
      views: {
        'container@auth': {
          template: require('../components/parameters/accounts/accounts-material.html'),
          controller: 'AccountsController'
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.catalogs', {
      url: '/catalogs',
      views: {
        'container@auth': {
          template: require('../components/parameters/catalogs/catalogs-material.html'),
          controller: 'CatalogsController'
        }
      }
    })
    .state('auth.alcmeon.fuse.account-edit', {
      url: '/account-edit/:id?error',
      views: {
        'container@auth': {
          template: require('../components/parameters/accounts/account-edition-material.html'),
          controller: 'AccountEditionController'
        }
      }
    })
    .state('auth.alcmeon.fuse.site-group-edit', {
      url: '/site-group-edit/:id?error',
      views: {
        'container@auth': {
          template: require('../components/parameters/site-groups/site-group-edition-material.html'),
          controller: 'SiteGroupEditionController'
        }
      }
    })

    .state('auth.alcmeon.parameters', {
      abstract: true,
      url: '/parameters',
      views: {
        'sub-nav@auth': {
          template: require('../components/core/subnav/navigation.parameters.html'),
          controller: 'NavigationParametersController'
        }
      }
    })
    // retrocompatibility, redirection to new state
    .state('auth.alcmeon.parameters.sessions-settings', {
      url: '/sessions-settings',
      views: {
        'container@auth': {
          controller: ['$state', function ($state) {
            // ui-router is too old, redirectTo doesn't work
            $state.go('auth.alcmeon.parameters.sessions');
          }]
        }
      }
    })
    .state('auth.alcmeon.parameters.sessions', {
      url: '/sessions',
      views: {
        'container@auth': {
          template: '<angular-sessions></angular-sessions>',
        }
      }
    })
    .state('auth.alcmeon.parameters.reports', {
      url: '/reports',
      views: {
        'container@auth': {
          template: require('../components/parameters/reports/reports.html'),
          controller: 'ReportsController'
        }
      }
    })
    .state('auth.alcmeon.parameters.users', {
      url: '/users',
      views: {
        'container@auth': {
          template: require('../components/parameters/users/users.html'),
          controller: 'UsersController'
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.custom-field', {
      url: '/custom-field?requestedPage',
      views: {
        'container@auth': {
          template: require('../components/parameters/custom-field/custom-field.html'),
          controller: 'CustomFieldController'
        }
      }
    })
    .state('auth.alcmeon.parameters.add-account-fb-old', {
      url: '/add-account-fb-old?requestId&siteId&code',
      views: {
        'container@auth': {
          template: require('../components/parameters/addAccountFbOld/addAccountFb.html'),
          controller: 'AddAccountFbOldController'
        }
      }
    })
    .state('auth.alcmeon.parameters.add-meta-business-manager-list', {
      url: '/add-meta-business-manager/list?code',
      views: {
        'container@auth': {
          template: require('../components/parameters/add-meta-business-manager-list/addMetaBusinessManagerList.html'),
          controller: 'AddMetaBusinessManagerListController'
        }
      }
    })
    .state('auth.alcmeon.parameters.add-meta-catalog-list', {
      url: '/add-meta-catalog/list?businessManagerId&code',
      views: {
        'container@auth': {
          template: require('../components/parameters/add-meta-catalog-list/addMetaCatalogList.html'),
          controller: 'AddMetaCatalogListController'
        }
      }
    })
    .state('auth.alcmeon.parameters.add-account-linkedin', {
      url: '/add-account-linkedin?authId&siteId&code',
      views: {
        'container@auth': {
          template: require('../components/parameters/addAccountLinkedin/addAccountLinkedin.html'),
          controller: 'AddAccountLinkedinController'
        }
      }
    })
    .state('auth.alcmeon.parameters.trustpilot-add-account', {
      url: '/trustpilot/{requestId:int}/extra',
      views: {
        'container@auth': {
          template: require('../components/parameters/addAccountTrustpilot/addAccountTrustpilot.html'),
          controller: 'AddAccountTrustpilotController'
        }
      }
    })
    .state('auth.alcmeon.parameters.webchat-add-account', {
      url: '/webchat/{requestId:int}/extra',
      views: {
        'container@auth': {
          template: require('../components/parameters/addAccountWebchat/addAccountWebchat.html'),
          controller: 'AddAccountWebchatController'
        }
      }
    })
    .state('auth.alcmeon.parameters.business-chat-add-account', {
      url: '/business-chat/{requestId:int}/extra',
      views: {
        'container@auth': {
          template: require('../components/parameters/addAccountBusinessChat/addAccountBusinessChat.html'),
          controller: 'AddAccountBusinessChatController'
        }
      }
    })
    .state('auth.alcmeon.parameters.landing-page', {
      url: '/business-chat/landing-page',
      views: {
        'container@auth': {
          template: require('../components/parameters/addAccountBusinessChat/addAccountBusinessChatLandingPage.html'),
          controller: 'AddAccountBusinessChatLandingPageController'
        }
      }
    })
    .state('auth.alcmeon.parameters.business-chat-add-account-confirmation', {
      url: '/business-chat/confirmation?createdSiteId',
      views: {
        'container@auth': {
          template: require('../components/parameters/addAccountBusinessChat/addAccountBusinessChatConfirmation.html'),
          controller: 'AddAccountBusinessChatConfirmationController'
        }
      }
    })
    .state('auth.alcmeon.parameters.account', {
      url: '/account/:siteId',
      abstract: true,
      resolve: {
        site: ['$stateParams', 'ParametersFactory', function ($stateParams, ParametersFactory) {
          return ParametersFactory.getSite($stateParams.companyId, $stateParams.siteId).then(function (response) {
            return response.data;
          });
        }],
        siteType: ['site', function (site) {
          return site.type_name;
        }]
      }
    })
    .state('auth.alcmeon.parameters.all-accounts', {
      url: '/all-accounts',
      abstract: true
    })
    .state('auth.alcmeon.parameters.tags-groups', {
      url: '/tags-groups',
      resolve: {
        tagsGroups: ['$stateParams', 'ParametersFactory', function ($stateParams, ParametersFactory) {
          return ParametersFactory.getTagGroups($stateParams.companyId).then(function (response) {
            return response.data;
          });
        }]
      },
      views: {
        'container@auth': {
          template: require('../components/parameters/tags/parameters.tags-groups.html'),
          controller: 'ParametersTagsGroupsController'
        }
      }
    })
    .state('auth.alcmeon.parameters.tags-groups.details', {
      url: '/:tagGroupId',
      resolve: {
        myTagGroup: ['$stateParams', 'ParametersFactory', function ($stateParams, ParametersFactory) {
          return ParametersFactory.getTagGroup($stateParams.companyId, $stateParams.tagGroupId).then(function (response) {
            return response.data;
          });
        }],
        myTagGroups: ['tagsGroups', function (tagsGroups) {
          return tagsGroups;
        }]
      },
      views: {
        'container@auth': {
          template: require('../components/parameters/tags/parameters.tag-group.html'),
          controller: 'ParametersTagGroupController'

        }
      }
    })
    .state('auth.alcmeon.fuse.publications', {
      url: '/publications',
      views: {
        'container@auth': {
          template: require('../components/publications/publications.html'),
          controller: 'PublicationListController',
        }
      }
    })
    // url received by email, via triage rule "Notify by email"
    .state('auth.alcmeon.maybe-login-then-redirect', {
      url: '/login-then-redirect?{redirectAfterLoginUrl:any}', // :any to work around slash double-url-encoding, see https://github.com/angular-ui/ui-router/issues/1645#issuecomment-85637641
      params: {
        redirectAfterLoginUrl: null,
      },
      resolve: {
        maybeLogin: ['$stateParams', 'loggedUser', 'LoginFactory', 'initFromSelf',
          function ($stateParams, loggedUser, LoginFactory) { // loggedUser injected param forces login
            LoginFactory.addJwtShortToUrl($stateParams.redirectAfterLoginUrl).then((urlWithJwt) => {
              window.location.href = urlWithJwt;
            })
          }]
      }
    })
    .state('auth.alcmeon.fuse.parameters.company-contacts', {
      url: '/company-contacts',
      resolve: {
        companyContacts: ['$stateParams', 'CompanyContactsFactory', function ($stateParams, CompanyContactsFactory) {
          return CompanyContactsFactory.getCompanyContacts($stateParams.companyId).then(response => response.data);
        }]
      },
      views: {
        'container@auth': {
          template: require('../components/parameters/company-contacts/company-contacts.html'),
          controller: 'CompanyContactsController'
        }
      }
    })
    ;
  addSatisfactionSurveyStates($stateProvider, 'care');
  addSatisfactionSurveyStates($stateProvider, 'marketing');
}
